"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const pLimit = require("./pLimit.cjs");
const DEFAULT_RETRY_AFTER = 1500;
const THROTTLED_RUNNERS = {};
const DEDUPLICATED_JOBS = {};
async function request(url, init, fetchFn) {
  var _a, _b;
  const stringURL = url.toString();
  let job;
  if (init == null ? void 0 : init.body) {
    const runner = THROTTLED_RUNNERS[_a = url.hostname] || (THROTTLED_RUNNERS[_a] = pLimit.pLimit({
      interval: DEFAULT_RETRY_AFTER
    }));
    job = runner(() => fetchFn(stringURL, init));
  } else {
    const existingJob = (_b = DEDUPLICATED_JOBS[stringURL]) == null ? void 0 : _b.get(init == null ? void 0 : init.signal);
    if (existingJob) {
      job = existingJob;
    } else {
      job = fetchFn(stringURL, init).finally(() => {
        var _a2, _b2;
        (_a2 = DEDUPLICATED_JOBS[stringURL]) == null ? void 0 : _a2.delete(init == null ? void 0 : init.signal);
        if (((_b2 = DEDUPLICATED_JOBS[stringURL]) == null ? void 0 : _b2.size) === 0) {
          delete DEDUPLICATED_JOBS[stringURL];
        }
      });
      const map = DEDUPLICATED_JOBS[stringURL] || (DEDUPLICATED_JOBS[stringURL] = /* @__PURE__ */ new Map());
      map.set(init == null ? void 0 : init.signal, job);
    }
  }
  const response = await job;
  if (response.status === 429) {
    const retryAfter = Number(response.headers.get("retry-after"));
    const resolvedRetryAfter = Number.isNaN(retryAfter) ? DEFAULT_RETRY_AFTER : retryAfter * 1e3;
    await new Promise((resolve) => setTimeout(resolve, resolvedRetryAfter));
    return request(url, init, fetchFn);
  }
  return response.clone();
}
exports.DEFAULT_RETRY_AFTER = DEFAULT_RETRY_AFTER;
exports.request = request;
//# sourceMappingURL=request.cjs.map
